module.exports = __webpack_public_path__ + "img/paid.bbbaa8cc.gif";